import React from 'react'
import OnlineUser from '../online/OnlineUser'
import './user.css'

const User = ({info, data}) => {

      const name = info.code || info.name.length === 0 ? data.info.name : info.name
      const dicebear = `https://api.dicebear.com/5.x/initials/svg?seed=${name}&fontSize=28`
      const avatar = info.code || info.avatar.length === 0 ? dicebear : info.avatar 
      const status = info.code || info.status.length === 0 ? data.info.status : info.status
      const id_xat = info.code || info.id_xat.length === 0 ? data.info.id_xat : info.id_xat

      return (
            <div className="user_content">
                  <div className="user_avatar">
                        <div className="user_avatar__effect"></div>
                        <div className="user_avatar__img flex">
                              <img src={avatar} alt={name} />
                        </div>
                  </div>
                  <div className="user_data">
                        <p>{status}</p>
                        <OnlineUser id={id_xat} />
                        <div className="id_content">
                              {id_xat}
                        </div>
                  </div>
            </div>
      )
}

export default User
